import React, { useEffect, useState } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';

export default function ParentTicketList() {
    const { http, user } = AuthUser();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        fetchRows();
    }, []);

    const fetchRows = async () => {
        setLoading(true);
        try {
            const response = await http.get(`/parent_tickets?company_id=${user.company_id}`);
            if (response.data.success) {
                setRows(response.data.data || []);
            } else {
                toast.error(response.data.message || 'Failed to load tickets');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error loading tickets');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toaster />
            <div className="container-fluid mt-4 px-4">
                <div className="row mb-4">
                    <div className="col-12 d-flex justify-content-between align-items-start">
                        <div>
                            <h3 className="mb-1">Parent Tickets</h3>
                            <p className="text-muted mb-0">
                                Help / support tickets created by parents from the mobile app.
                            </p>
                        </div>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={fetchRows}
                            disabled={loading}
                        >
                            Refresh
                        </button>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border" role="status" />
                            </div>
                        ) : rows.length === 0 ? (
                            <p className="text-muted text-center mb-0 py-4">No tickets yet.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Created</th>
                                            <th>Student</th>
                                            <th>Class</th>
                                            <th>Subject</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>{index + 1}</td>
                                                <td className="text-nowrap">
                                                    {row.created_at_display || row.created_at}
                                                </td>
                                                <td>
                                                    <div>
                                                        <strong>{row.student_name || '—'}</strong>
                                                    </div>
                                                    <small className="text-muted">
                                                        Adm: {row.admission_no || '—'} · {row.email || '—'}
                                                    </small>
                                                </td>
                                                <td>
                                                    {row.class || '—'}
                                                    {row.division ? `-${row.division}` : ''}
                                                </td>
                                                <td>{row.subject}</td>
                                                <td>
                                                    <span className="badge bg-warning text-dark text-capitalize">
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => setSelected(row)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {selected && (
                <div
                    className="modal show d-block"
                    tabIndex={-1}
                    style={{ background: 'rgba(0,0,0,0.45)' }}
                    onClick={() => setSelected(null)}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{selected.subject}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSelected(null)}
                                />
                            </div>
                            <div className="modal-body">
                                <p className="mb-2">
                                    <strong>Student:</strong> {selected.student_name || '—'} (
                                    {selected.admission_no || '—'})
                                </p>
                                <p className="mb-2">
                                    <strong>Class:</strong> {selected.class || '—'}-
                                    {selected.division || '—'}
                                </p>
                                <p className="mb-2">
                                    <strong>Email:</strong> {selected.email || '—'}
                                </p>
                                <p className="mb-2">
                                    <strong>Created:</strong>{' '}
                                    {selected.created_at_display || selected.created_at}
                                </p>
                                <hr />
                                <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                    {selected.description}
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setSelected(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
